import { PlanungModules } from '@bp/pim-auth-constants';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { usePermissionChecker } from '../../hooks/usePermissionChecker';
import { LicenseHintKind } from './LicenseHint';

/**
 * Das nicht gebuchte Modul der aktuellen Seite (aus dem ersten Pfadteil: Deputate, Stundenplan, Vertretungen), sonst
 * `null`. Für das Schloss im Seitenkopf: Module ohne Buchung sind nutzbar, sollen aber nicht wie gebucht aussehen.
 */
export const useUnlicensedModule = (): LicenseHintKind | null => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const permissions = usePermissionChecker();
  const section = pathname.split('/')[1];

  if (section === t('routes.deputate.slug') && !permissions?.isDeputateEnabled()) {
    return { kind: 'trial', module: PlanungModules.teachingLoad };
  }
  if (section === t('routes.timetable.slug') && !permissions?.isTimetableEnabled()) {
    return { kind: 'trial', module: PlanungModules.timetable };
  }
  if (section === t('routes.substitutions.slug') && !permissions?.isSubstitutionsEnabled()) {
    return { kind: 'trial', module: PlanungModules.substitution };
  }
  return null;
};
